import React from 'react';
import { clsx } from 'clsx';
import { Target } from 'lucide-react';
import patterns from '@/shared/ui/styles/patterns.module.css';
import styles from './StrategyBadge.module.css';

interface Props {
  title: string;
  className?: string;
}

export function StrategyBadge({ title, className }: Props) {
  return (
    <span
      className={clsx(patterns.pill, patterns.pillPurple, patterns.pillUppercase, styles.badge, className)}
    >
      <Target size={11} aria-hidden /> {title}
    </span>
  );
}
